import React, { useState, useEffect } from 'react';
import { Button, Typography, Box } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import { API_URL } from "./lib/utils";
import { LogIn as LoginIco } from 'lucide-react';

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const pulse = keyframes`
    0% {
        box-shadow: 0 0 0 0 rgba(66, 133, 244, 0.4);
    }
    60% {
        box-shadow: 0 0 0 12px rgba(66, 133, 244, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(66, 133, 244, 0);
    }
`;

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: '20px',
    padding: '12px 24px',
    fontSize: '1rem',
    borderRadius: '50px',
    textTransform: 'none',
    backgroundColor: '#4285F4',
    '&:hover': {
        backgroundColor: '#3367D6',
    },
    animation: `${pulse} 2s infinite`,
    animationDelay: '1s', // Add delay for stagger effect
    // opacity: 0,
    animationFillMode: 'forwards',
}));

const LoginContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#1a1a1a',
    color: '#ffffff',
}));

const LoginContent = styled(Box)(({ theme }) => ({
    textAlign: 'center',
    animation: `${fadeIn} 1s ease-out`,
    animationFillMode: 'forwards',
}));

const Login = () => {
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setShowButton(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <LoginContainer>
            <LoginContent>
                <Typography variant="h3" gutterBottom>
                    Welcome Back!
                </Typography>
                <StyledButton
                    variant="contained"
                    startIcon={<LoginIco />}
                    href={`${API_URL}/auth/google`}
                    style={{ animationDelay: showButton ? '0s' : '1s' }} // Conditional animation delay
                >
                    Sign in with Google
                </StyledButton>
            </LoginContent>
        </LoginContainer>
    );
};

export default Login;
